import React from 'react';

const publications = {
    "2026": [

        {
            serialNumber: 22,
            url: "https://academic.oup.com/nar/advance-article-abstract/doi/10.1093/nar/gkag384/8709442",
            citation: 'Marwaha, D., Sharma, A., Saini, K., Singh, A. K., Bhaskar, A., & Ray, A. (2026). LiMeNEx: an interactive webserver on lipid biochemical gene-regulatory network. Nucleic Acids Research, gkag384.'
        },

        {
            serialNumber: 21,
            url: "https://pubs.acs.org/doi/abs/10.1021/acsomega.5c01567",
            citation: 'Dada, N. Y., Shah, M. Z., Sacher, S., Govindh, M. P., Bhedsurkar, P., Nair, R. R., ... & Kamble, S. S. (2026). Molecular Insights into Anabaenopeptin-Mediated Inhibition of Protein Tyrosine Phosphatase B in the Mycobacterium tuberculosis Complex. ACS omega, 11(14), 21556-21576.'
        },

        {
            serialNumber: 20,
            url: "https://spj.science.org/doi/abs/10.34133/csbj.0122",
            citation: 'Sacher, S., Singh, P., Mukherjee, A., Bhaskar, A. K., Chakraborty, K., Counillon, L., ... & Ray, A. (2026). Phospholipids that Plug the Pores of Cholesteryl Ester Transfer Protein Control Its Triglyceride Transfer. Computational and Structural Biotechnology Journal, 35(1), 0122.'
        },

    ],   
    "2025": [
         {
            serialNumber: 19,
            url: "https://scholar.google.com/scholar?hl=en&as_sdt=0%2C5&q=Sacher%2C+S.%2C+Afroz%2C+S.%2C+Kaur%2C+A.+and+Ray%2C+A.+*%2C+2026.+Lipid%E2%80%93protein+interactions+and+molecular+dynamics+simulation.+In+Lipid+Analysis+in+Biology%2C+Health%2C+and+Disease+%28pp.+23-35%29.+Academic+Press.+https%3A%2F%2Fdoi.org%2F10.1016%2FB978-0-443-19116-9.00021-X.&btnG=",
            citation: 'Sacher, Sukriti, et al. "Lipid–protein interactions and molecular dynamics simulation." Lipid Analysis in Biology, Health, and Disease. Academic Press, 2026. 23-35.'
        },
         {
            serialNumber: 18,
            url: "https://scholar.google.com/scholar?hl=en&as_sdt=0%2C5&q=Kaur%2C+A.%2C+Saha%2C+S.%2C+Ujjainiya%2C+R.%2C+Ray%2C+A.%2C+Basak%2C+T.+and+Sengupta%2C+S.%2C+2026.+Apolipoproteins+and+cardiovascular+diseases.+In+Lipid+Analysis+in+Biology%2C+Health%2C+and+Disease+%28pp.+371-406%29.+Academic+Press.+https%3A%2F%2Fdoi.org%2F10.1016%2FB978-0-443-19116-+9.00032-4&btnG=",
            citation: 'Kaur, Arvinpreet, et al. "Apolipoproteins and cardiovascular diseases." Lipid Analysis in Biology, Health, and Disease. Academic Press, 2026. 371-406.'
        },
        {
            serialNumber: 17,
            url: "https://scholar.google.com/scholar?hl=en&as_sdt=0%2C5&q=Sarah%2C+S.R.%2C+Garg%2C+A.%2C+Afroz%2C+S.%2C+Korch%2C+S.%2C+Ray%2C+A.%2C+Gupta%2C+A.+and+Malhotra%2C+V.%2C+2025.+Ser%2FThr+phosphorylation+of+Mycobacterium+tuberculosis+type+II+RelK+toxin+by+PknK+destabilizes+TA+interaction+and+interferes+with+toxin+neutralization.+mBio%2C+pp.e01068-25.+doi%3A+10.1128%2Fmbio.01068-25.&btnG=",
            citation: 'Sarah, Shafinaz Rahman, et al. "Ser/Thr phosphorylation of Mycobacterium tuberculosis type II RelK toxin by PknK destabilizes TA interaction and interferes with toxin neutralization." mBio (2025): e01068-25.'
        },
          {
            serialNumber: 16,
            url: "https://scholar.google.com/scholar?hl=en&as_sdt=0%2C5&q=Francis%2C+A.X.%2C+Chilkoti%2C+M.%2C+Atul%2C+Mrinal%2C+Sacher%2C+S.*+and+Ray%2C+A.*%2C+2025.+An+Algorithm-Based+Investigation+to+Reveal+the+Differential+Dynamics+of+Water+inside+Protein+Cavities+as+a+Function+of+Distance+from+Their+Wall.+Journal+of+Chemical+Information+and+Modeling%2C+65%2810%29%2C+pp.5176-5187.+doi%3A+10.1021%2Facs.jcim.5c00448.&btnG=",
            citation: 'Francis, Abel Xavier, et al. "An Algorithm-Based Investigation to Reveal the Differential Dynamics of Water inside Protein Cavities as a Function of Distance from Their Wall." Journal of Chemical Information and Modeling 65.10 (2025): 5176-5187.'
        },
        {
            serialNumber: 15,
            url: "https://scholar.google.com/scholar?hl=en&as_sdt=0%2C5&q=Molecular+Modeling+of+Non-Canonical+Intramolecular+RNA+Triple+Helix+Structures+Predicted+from+TRIPinRNA+and+Their+In+Vitro+Biophysical+Structure+Validation&btnG=",
            citation: 'Rakheja, Isha, et al. "Molecular Modeling of Non-Canonical Intramolecular RNA Triple Helix Structures Predicted from TRIPinRNA and Their In Vitro Biophysical Structure Validation." The Journal of Physical Chemistry B 129.18 (2025): 4298-4308.'
        },
     ],

    "2024": [
        {
            serialNumber: 14,
            url: "https://scholar.google.com/scholar?hl=en&as_sdt=0%2C5&q=Deciphering+Cas9+specificity%3A+Role+of+domain+dynamics+and+RNA%3ADNA+hybrid+interactions+revealed+through+machine+learning+and+accelerated+molecular+simulations&btnG=",
            citation: 'Panda, Gayatri, and Arjun Ray. "Deciphering Cas9 specificity: Role of domain dynamics and RNA: DNA hybrid interactions revealed through machine learning and accelerated molecular simulations." International Journal of Biological Macromolecules 283 (2024): 137835.'
        },
        {
            serialNumber: 13,
            url: "https://scholar.google.com/scholar?hl=en&as_sdt=0%2C5&q=In+Silico+Strategies+for+Characterizing+Inner+Cavities+of+Lipid-Binding+Proteins&btnG=",
            citation: 'Sacher, Sukriti, and Arjun Ray. "In Silico Strategies for Characterizing Inner Cavities of Lipid-Binding Proteins." Intracellular Lipid Transport: Methods and Protocols. New York, NY: Springer US, 2024. 305-320.'
        },
     ],

    "2023": [
        {
            serialNumber: 1,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:gVv57TyPmFsC",
            citation: 'Sacher, Sukriti, Abhishek Mukherjee, and Arjun Ray. "Deciphering structural aspects of reverse cholesterol transport: mapping the knowns and unknowns." Biological Reviews 98.4 (2023): 1160-1183.'
        },
        {
            serialNumber: 2,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:Ak0FvsSvgGUC",
            citation: 'gautam, prutyay, et al. "DIGEST: An online tool for designing of multiple reaction monitoring assays." bioRxiv (2023): 2023-11.'
        },
        {
            serialNumber: 11,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:BJbdYPG6LGMC",
            citation: 'Mishra, Shreya, et al. "An explainable model using Graph-Wavelet for predicting biophysical properties of proteins and measuring mutational effects." IEEE Access 11 (2023): 135222-135234.'
        },
        {
            serialNumber: 12,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:vDZJ-YLwNdEC",
            citation: 'Ray, Sarbajit, et al. "Identification of pseudobaptigenin as a novel polyphenol-based multi-target antagonist of different hormone receptors for breast cancer therapeutics." Journal of Biomolecular Structure and Dynamics (2023): 1-13.'
        }
    ],
    "2022": [
        {
            serialNumber: 3,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:u-coK7KVo8oC",
            citation: 'Panda, Gayatri, and Arjun Ray. "Decrypting the mechanistic basis of CRISPR/Cas9 protein." Progress in Biophysics and Molecular Biology 172 (2022): 60-76.'
        },
        {
            serialNumber: 4,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:8xutWZnSdmoC",
            citation: 'Garg, Parth, et al. "CICLOP: a robust and accurate computational framework for protein inner cavity detection." Bioinformatics 38.8 (2022): 2153-2161.'
        },
        {
            serialNumber: 5,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:5MTHONV0fEkC",
            citation: 'Panda, Gayatri, and Arjun Ray. "Comparative structural and dynamics study of free and gRNA-bound FnCas9 and SpCas9 proteins." Computational and Structural Biotechnology Journal 20 (2022): 4172-4184.'
        },
        {
            serialNumber: 6,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&cstart=20&pagesize=80&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:GFxP56DSvIMC",
            citation: 'Sacher, Sukriti, and Arjun Ray. "Solvation Dynamics of a Single Triglyceride as a Function of its Chain Length." bioRxiv (2022): 2022-03.'
        },
        {
            serialNumber: 8,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:LhH-TYMQEocC",
            citation: 'Sunidhi, S., et al. "Elucidating the structural features of ABCA1 in its heterogeneous membrane environment." Frontiers in Molecular Biosciences 8 (2022): 803078.'
        },
        {
            serialNumber: 9,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&cstart=20&pagesize=80&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:a3BOlSfXSfwC",
            citation: 'Panda, Gayatri, et al. "Comprehensive assessment of Indian variations in the druggable kinome landscape highlights distinct insights at the sequence, structure and pharmacogenomic stratum." Frontiers in Pharmacology 13 (2022): 858345.'
        },
        {
            serialNumber: 13,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:lvd772isFD0C",
            citation: 'Rakheja, Isha, et al. "Small molecule quercetin binds MALAT1 triplex and modulates its cellular function." Molecular Therapy-Nucleic Acids 30 (2022): 241-256.'
        },
        {
            serialNumber: 14,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:ZzlSgRqYykMC",
            citation: 'Rao, Kannan Boosi Narayana, et al. "Stress responses elicited by misfolded proteins targeted to mitochondria." Journal of Molecular Biology 434.12 (2022): 167618.'
        },
        {
            serialNumber: 15,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:Aul-kAQHnToC",
            citation: 'Sadat, Anwar, et al. "Conserved and divergent chaperoning effects of Hsp60/10 chaperonins on protein folding landscapes." Proceedings of the National Academy of Sciences 119.18 (2022): e2118465119.'
        },
        {
            serialNumber: 16,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:fbc8zXXH2BUC",
            citation: 'Bhaskar, Akash Kumar, et al. "A high throughput lipidomics method using scheduled multiple reaction monitoring." Biomolecules 12.5 (2022): 709.'
        },
        {
            serialNumber: 17,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:_OXeSy2IsFwC",
            citation: 'Haider, Madiha, et al. "Anti-SARS-CoV-2 potential of Cissampelos pareira L. identified by connectivity map-based analysis and in vitro studies." BMC Complementary Medicine and Therapies 22.1 (2022): 114.'
        }
    ],
    "2021": [
        {
            serialNumber: 18,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&cstart=20&pagesize=80&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:OP4eGU-M3BUC",
            citation: 'Haider, Madiha, et al. "Transcriptome analysis and connectivity mapping of Cissampelos pareira L. provides molecular links of ESR1 modulation to viral inhibition." Scientific Reports 11.1 (2021): 20095.'
        },
        {
            serialNumber: 19,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&cstart=20&pagesize=80&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:P7Ujq4OLJYoC",
            citation: 'Sehgal, Paras, et al. "LncRNA VEAL2 regulates PRKCB2 to modulate endothelial permeability in diabetic retinopathy." The EMBO Journal 40.15 (2021): e107134.'
        },
        {
            serialNumber: 20,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&cstart=20&pagesize=80&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:r_AWSJRzSzQC",
            citation: 'Ansari, Shoyab, et al. "Contrasting conformational dynamics of β-sheet A and helix F with implications in neuroserpin inhibition and aggregation." International Journal of Biological Macromolecules 176 (2021): 117-125.'
        },
        {
            serialNumber: 21,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&cstart=20&pagesize=80&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:yqoGN6RLRZoC",
            citation: 'Haider, Madiha, et al. "Traditional use of Cissampelos pareira L. for hormone disorder and fever provides molecular links of ESR1 modulation to viral inhibition." BioRxiv (2021): 2021-02.'
        },
        {
            serialNumber: 22,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&cstart=20&pagesize=80&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:HeT0ZceujKMC",
            citation: 'Bhaskar, Akash Kumar, et al. "A high content lipidomics method using scheduled MRM with variable retention time window and relative dwell time weightage." bioRxiv (2021): 2021-01.'
        }    


],
    "2020": [
            {
            serialNumber: 23,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&cstart=20&pagesize=80&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:KbBQZpvPDL4C",
            citation: 'Mal, Arijit, et al. "In Silico Identification of Potential Phosphorylation in the Cytoplasmic Domain of Epithelial Cell Adhesion Molecule." ACS omega 5.48 (2020): 30808-30816.'
        },
        {
            serialNumber: 24,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&cstart=20&pagesize=80&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:OcBU2YAGkTUC",
            citation: 'Sadat, Anwar, et al. "GROEL/ES buffers entropic traps in folding pathway during evolution of a model substrate." Journal of molecular biology 432.20 (2020): 5649-5664.'
        },
        {
            serialNumber: 25,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&cstart=20&pagesize=80&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:3htObqc8RwsC",
            citation: 'Singh, Praveen, et al. "A rapid and sensitive method to detect SARS-CoV-2 virus using targeted-mass spectrometry." Journal of Proteins and Proteomics 11.3 (2020): 159-165.'
        },
        {
            serialNumber: 26,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&cstart=20&pagesize=80&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:OR75R8vi5nAC",
            citation: 'Chakraborty, Debojyoti, et al. "Highly Precise Ex Vivo Correction of Sickle Cell Anemia Mutation in Patient Cells Using FnCas9." MOLECULAR THERAPY. Vol. 28. No. 4. 50 HAMPSHIRE ST, FLOOR 5, CAMBRIDGE, MA 02139 USA: CELL PRESS, 2020.'
        },
        {
            serialNumber: 27,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&cstart=20&pagesize=80&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:yFnVuubrUp4C",
            citation: 'Kumar, Vignesh, et al. "Interdomain communication suppressing high intrinsic ATP ase activity of Sse1 is essential for its co‐disaggregase activity with Ssa1." The FEBS journal 287.4 (2020): 671-694.'
        },
        {
            serialNumber: 28,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&cstart=20&pagesize=80&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:fFSKOagxvKUC",
            citation: 'Rao, Kannan Boosi Narayana, et al. "Localized Proteotoxic Stress in Mitochondrial Intermembrane Space and Matrix Elicits Sub-compartment Specific Response Pathways Governed by Unique Modulators." bioRxiv. (2020).'
        },
        {
            serialNumber: 29,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&cstart=20&pagesize=80&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:HtS1dXgVpQUC",
            citation: 'Acharya, Sundaram, et al. "Francisella novicida Cas9 interrogates genomic DNA with very high specificity and can be used for mammalian genome editing." Proceedings of the National Academy of Sciences 116.42 (2019): 20959-20968.'
        }
    ],
    "2019": [
        {
            serialNumber: 30,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&cstart=20&pagesize=80&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:DJbcl8HfkQkC",
            citation: 'Silla, Yumnam, et al. "Hydrolysis of homocysteine thiolactone results in the formation of Protein‐Cys‐S‐S‐homocysteinylation." Proteins: Structure, Function, and Bioinformatics 87.8 (2019): 625-634.'
        },
        {
            serialNumber: 31,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&cstart=20&pagesize=80&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:bKqednn6t2AC",
            citation: 'Kumar, Sandeep, et al. "Cholic acid-derived amphiphile which combats gram-positive bacteria-mediated infections via disintegration of lipid clusters." ACS Biomaterials Science & Engineering 5.9 (2019): 4764-4775.'
        }
    ],
    "2018": [
            {
            serialNumber: 32,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&cstart=20&pagesize=80&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:mlAyqtXpCwEC",
            citation: 'Ray, Arjun, et al. "Specific cholesterol binding drives drastic structural alterations in Apolipoprotein A1." The Journal of Physical Chemistry Letters 9.20 (2018): 6060-6065.'
        },
        {
            serialNumber: 33,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&cstart=20&pagesize=80&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:4vMrXwiscB8C",
            citation: 'Ghosh, Arpita, et al. "Targeting miRNA by tunable small molecule binders: peptidic aminosugar mediated interference in miR-21 biogenesis reverts epithelial to mesenchymal transition." MedChemComm 9.7 (2018): 1147-1154.'
        },
        {
            serialNumber: 34,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&cstart=20&pagesize=80&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:IRz6iEL74y4C",
            citation: 'Ray, Arjun, Frauke Gräter, and Lipi Thukral. "Probing molecular forces in multi-component physiological membranes." Physical Chemistry Chemical Physics 20.4 (2018): 2155-2161.'
        }
    ],
    "2017": [
        {
            serialNumber: 35,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&cstart=20&pagesize=80&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:WJVC3Jt7v1AC",
            citation: 'Kumar, Vignesh, et al. "Atypical domain communication and domain functions of a Hsp110 chaperone." bioRxiv (2017): 220798.'
        },
        {
            serialNumber: 36,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&cstart=20&pagesize=80&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:6ZxmRoH8BuwC",
            citation: 'Ray, Arjun, Nidhi Jatana, and Lipi Thukral. "Lipidated proteins: spotlight on protein-membrane binding interfaces." Progress in biophysics and molecular biology 128 (2017): 74-84.'
        },
        {
            serialNumber: 37,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&cstart=20&pagesize=80&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:2VqYfGB8ITEC",
            citation: 'Bansal, Trisha, et al. "Arjunolic acid, a peroxisome proliferator-activated receptor α agonist, regresses cardiac fibrosis by inhibiting non-canonical TGF-β signaling." Journal of Biological Chemistry 292.40 (2017): 16440-16462.'
        },
        {
            serialNumber: 38,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&cstart=20&pagesize=80&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:_5tno0g5mFcC",
            citation: 'Paul, Deepanjan, et al. "A-to-I editing in human miRNAs is enriched in seed sequence, influenced by sequence contexts and significantly hypoedited in glioblastoma multiforme." Scientific Reports 7.1 (2017): 2466.'
        }
    ],
    "2015": [
        {
            serialNumber: 39,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&cstart=20&pagesize=80&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:IjCSPb-OGe4C",
            citation: 'Silla, Y., Ray, A., Thukral, L., & Sengupta, S. (2015). MOLECULAR MODELING INDICATES THAT HOMOCYSTEINE INDUCES CONFORMATIONAL CHANGES IN THE STRUCTURE OF PUTATIVE TARGET PROTEINS. Journal of Proteins & Proteomics, 6(3).'
        },
        {
            serialNumber: 40,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&cstart=20&pagesize=80&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:2osOgNQ5qMEC",
            citation: 'Bose, Debojit, et al. "Selective inhibition of miR-21 by phage display screened peptide." Nucleic acids research 43.8 (2015): 4342-4352.'
        },
        {
            serialNumber: 41,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&cstart=20&pagesize=80&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:qjMakFHDy7sC",
            citation: 'Nahar, Smita, et al. "Potent inhibition of miR-27a by neomycin–bisbenzimidazole conjugates." Chemical Science 6.10 (2015): 5837-5846.'
        }
    ],
    "2012": [
    	{
            serialNumber: 42,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&cstart=20&pagesize=80&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:9yKSN-GCB0IC",
            citation: 'Ray, Arjun, Erik Lindahl, and Björn Wallner. "Improved model quality assessment using ProQ2." BMC bioinformatics 13 (2012): 1-12.'
        },
        {
            serialNumber: 43,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&cstart=20&pagesize=80&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:d1gkVwhDpl0C",
            citation: 'Ray, Arjun, Erik Lindahl, and Björn Wallner. "Evolutionary information and multiple sequence alignments improve protein model guality prediction." (2012).'
        }
    ],
    "2014": [
        {
            serialNumber: 45,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&cstart=20&pagesize=80&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:u5HHmVD_uO8C",
            citation: 'Studer, Gabriel, Marco Biasini, and Torsten Schwede. "Assessing the local structural quality of transmembrane protein models using statistical potentials (QMEANBrane)." Bioinformatics 30.17 (2014): i505-i511.'
        }
    ],

    "2008": [
        {
            serialNumber: 44,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&cstart=20&pagesize=80&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:u-x6o8ySG0sC",
            citation: 'Wallner, Björn, and Arne Elofsson. "Quality assessment of protein models." Prediction of protein structures, functions, and interactions (2008): 143-157.'
        }
    ],

    "Article": [
    	{
            serialNumber: 46,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&cstart=20&pagesize=80&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:F9fV5C73w3QC",
            citation: 'Elucidating the structural feature of ABCA1 in heterogeneous membrane environment-Supplementary Data'
        },
        {
            serialNumber: 47,
            url: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&cstart=20&pagesize=80&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:sNmaIFBj_lkC",
            citation: 'Aditya, Anusha, et al. "REDUCE: development of a vermicomposting solution for urban household waste.".'
        }
    ]
};

const AllPublications = () => {
    return (
      <section
        id='publications'
        className='max-w-screen-xl mx-auto w-full h-fit pb-20 py-20 text-lightText flex flex-col border-b-[1px] border-b-black'
      >
        <div className='flex flex-col gap-8 font-titleFont'>
          <h1 className='text-5xl font-bold text-designColor text-center mb-8'>
            All Publications
          </h1>
          <div className='w-full'>
            {Object.keys(publications).sort((a, b) => b - a).map((year, index) => (
              <div key={index} className='mb-8'>
                <h2 className='text-3xl font-semibold mb-4'>{year}</h2>
                <table className='w-full text-left border-collapse'>
                  <thead>
                    <tr>
                      <th className='border-b-2 border-designColor py-2'>Publication</th>
                      <th className='border-b-2 border-designColor py-2'>Link</th>
                    </tr>
                  </thead>
                  <tbody>
                    {publications[year].map((pub) => (
                      <tr key={pub.serialNumber}>
                        <td className='border-b border-designColor py-2 text-black'>{pub.citation}</td>
                        <td className='border-b border-designColor py-2 text-right'>
                          <a
                            href={pub.url}
                            target='_blank'
                            rel='noopener noreferrer'
                            className='underline text-navy'
                          >
                            Link
                          </a>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  };
  
  export default AllPublications;
  
